module.exports = __webpack_public_path__ + "static/media/SocialPiper-create.b1fe457c.jpg";